
import React from 'react';
import { Loader2 } from 'lucide-react';

const EventEditorLoading = () => {
  return (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <span className="ml-2 text-muted-foreground">Adatok betöltése...</span>
    </div>
  );
};

export default EventEditorLoading;
